import base from '../dr-base'
import drNavigation from './dr-navigation.vue'

const schema = {
  $Type: 'dr-navigation',
  name: 'Navigation',
  group: 'Menu widgets',
  icon: 'check-square',
  ...base,
  properties: {
    $ID: {
      name: 'vuetifyWidgets.dr-navigation.id',
      type: 'string'
    },
    DarkMode: {
      name: 'vuetifyWidgets.dr-navigation.darkMode',
      type: 'boolean',
      default: false,
      enum: [{
        value: true,
        text: 'vuetifyWidgets.dr-navigation.active'
      },{
        value: false,
        text: 'vuetifyWidgets.dr-navigation.notActive'
      }]
    },
    ExpandOnHover: {
      name: 'vuetifyWidgets.dr-navigation.expandOnHover',
      type: 'boolean',
      default: false,
      enum: [{
        value: true,
        text: 'vuetifyWidgets.dr-navigation.active'
      },{
        value: false,
        text: 'vuetifyWidgets.dr-navigation.notActive'
      }]
    },
    MiniVariant: {
      name: 'vuetifyWidgets.dr-navigation.miniVariant',
      type: 'boolean',
      default: false,
      enum: [{
        value: true,
        text: 'vuetifyWidgets.dr-navigation.active'
      },{
        value: false,
        text: 'vuetifyWidgets.dr-navigation.notActive'
      }]
    },
    Color: {
      name: 'vuetifyWidgets.dr-navigation.color',
      type: 'string',
      default: 'text',
      enum: [{
        value: 'primary',
        text: 'Primary'
      },{
        value: 'empty',
        text: 'Empty'
      },{
        value: 'accent',
        text: 'Accent'
      },{
        value: 'secondary',
        text: 'Secondary'
      }]
    },
  
    Widgets: {
      type: 'array'
    }
  }
}

export default {
  schema,
  component: drNavigation
}